import { Avatar } from '@eventbrite/eds-avatar';
import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import { css, cx } from 'emotion';
import React from 'react';
import './organizerPanel.scss';
import { GACodes } from './types';

interface Props {
    organizer: {
        name: string;
        logoUrl: string;
        description: string;
        url: string;
        of: string;
    };
    gaCategory: string;
    ownerOf?: string;
}

export const OrganizerPanel: React.FunctionComponent<Props> = ({
    organizer,
    gaCategory,
}) => {
    const _trackOrganizerView = () => {
        trackAnalyticsEvent({
            action: GACodes.ACTION_ORG_PAGE_VIEW,
            category: gaCategory,
            label: GACodes.LABEL_ORG_PANEL,
        });
    };

    return (
        <>
            {organizer.logoUrl && (
                <div className={css(styles.avatar)}>
                    <Avatar imageUrl={organizer.logoUrl} />
                </div>
            )}

            {organizer.name && (
                <div className="eds-l-mar-bot-2">
                    <h2 className="eds-text-bm">
                        <a
                            className="eds-btn eds-btn--button eds-btn--link"
                            href={organizer.url}
                            target="_blank"
                            rel="noreferrer"
                            onClick={_trackOrganizerView}
                        >
                            {organizer.name}
                        </a>
                    </h2>
                </div>
            )}

            {organizer.of && (
                <div className="eds-text-bm eds-l-mar-bot-4">
                    {gettext('Organizer of %(ownedItem)s', {
                        ownedItem: organizer.of,
                    })}
                </div>
            )}

            {organizer.description && (
                <div
                    className={cx(
                        'eds-text-bm',
                        'eds-text-color--grey-600',
                        'organizer-panel-description',
                        css(styles.description),
                    )}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: organizer.description }}
                ></div>
            )}
        </>
    );
};

const styles = {
    avatar: css`
        margin-bottom: 20px;

        @media (min-width: 794px) {
            margin-bottom: 8px;
        }
    `,
    description: css`
        text-align: center;
        margin-bottom: 24px;
        max-width: 100%;

        @media (min-width: 794px) {
            max-width: 80%;
        }

        p {
            padding-top: 12px;
            width: auto;
        }

        p:first-child {
            padding-top: 0;
        }
    `,
};
